import HyperSCORM from '../../libs/HyperScorm';
import SaveModel from '../../models/SaveModel';
import SpongePlugin from './SpongePlugin';

/**
 *
 * @category plugins
 * @export
 * @class TrackingPlugin
 * @extends {Phaser.Plugins.BasePlugin}
 */
export default class TrackingPlugin extends Phaser.Plugins.BasePlugin {

  /**
  *
  * load | save | complete | faild
  *
  * @constructor Creates an instance of the Tracking plugin
  * @param {Phaser.Plugins.PluginManager} pluginManager
  * @memberof GameData
  */
  constructor(pluginManager: Phaser.Plugins.PluginManager) {
    super(pluginManager);
    console.log("Tracking::constructor");

    this.events.on("load", this.loadFromExternal);
    // detect tracking version and setup.
  }

  init(): void {
    console.log("Tracking Controller::BOOT");
    // super.boot();
    this.assertSponge();



    if (this._sponge.data.model.trackingEnabled) {
    this._scorm = new HyperSCORM();
      if (this._scorm.connected) {
        console.log("Connected to scorm, registering as our tracking system");
        this.registerSCORMTrackingAndStorage();
      } else {
        console.log("unable to connect to scorm, registering OFFLINESTORAGE as our tracking");
        this.registerOfflineStorage();
      }

 console.log("Current Save:", this._sponge.data.save);

    this._sponge.data.save.progress++;
    this.save();

    }

   

  }

  /**
 * our instnace of the pipwreks-esque scorm wrapper
 *
 * @type {HyperScorm}
 * @memberof GameData
 */
  public _scorm: HyperSCORM | undefined;

  /**
   * refernce to global sponge tools
   *
   * @private
   * @type {SpongePlugin}
   * @memberof TrackingPlugin
   */
  private _sponge!: SpongePlugin;

  /**
   * event system in control of delegating the save / persistent data as well as module completion / pass.
   *
   * @type {Phaser.Events.EventEmitter}
   * @memberof TrackingPlugin
   */
  public events: Phaser.Events.EventEmitter = new Phaser.Events.EventEmitter();

  /**
   * force load of save model to specific model
   *
   * @private
   * @param {SaveModel} save
   * @memberof TrackingPlugin
   */
  private loadFromExternal(save: SaveModel): void {
    this.loadFromModel(save);
  }

  /**
   * save the model to any registered systems
   *
   * @memberof TrackingPlugin
   */
  public save(): void {

    this.assertSponge();

    if (this.events.listenerCount("save") > 0) {
      this.events.emit("save", this._sponge.data.save);
    } else {
      console.warn("no save implimentation on tracking controller");

    }
  }
  public load(): void {

    this.assertSponge();

    if (this.events.listenerCount("load") > 0) {
      this.events.emit("load");
    } else {
      console.warn("no load implimentation on tracking controller");

    }
  }

  /**
   * complete the module to any registered tracking systems
   *
   * @param {number} [score]
   * @memberof TrackingPlugin
   */
  public complete(score?: number): void {

    if (this.events.listenerCount("complete") > 0) {
      this.events.emit("complete", score);
    } else {
      console.warn("no complete implimentation on tracking controller");
    }
  }


  /**
   *dispach failed signal to any registered systems
   *
   * @param {number} [score]
   * @memberof TrackingPlugin
   */
  public failed(score?: number): void {
    if (this.events.listenerCount("failed") > 0) {
      this.events.emit("failed", score);
    } else {
      console.warn("no failed implimentation on tracking controller");
    }
  }



  /**
   * internal register to save on
   *
   * @private
   * @param {SaveModel} model
   * @memberof TrackingPlugin
   */
  private loadFromModel(model: SaveModel): void {
    this.assertSponge();
    try {
      this._sponge.data.save = model;
    } catch (e) {
      console.warn("error updating save model");
    }

  }

  private registerOfflineStorage(): void {
    console.log("Registering tracking with offline storage");

    this.events.on("save", () => {
      localStorage.setItem(this._sponge.data.save.identifier, JSON.stringify(this._sponge.data.save));
    });

    // load from Local Storage

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    const ls = JSON.parse(localStorage.getItem(this._sponge.data.save.identifier));


    if (ls && ls.version && ls.version === this._sponge.data.save.version && this._sponge.data.save.shouldPersistData) {
      this._sponge.data.save = JSON.parse(ls);
    } else {
      this.events.emit("save");
    }
  }

  private registerSCORMTrackingAndStorage(): void {
    console.log("Registering tracking with scorm");

    this.events.on("save", () => {
      if (this._scorm && this._scorm.suspendData) {
        this._scorm.suspendData = this._sponge.data.save;
        this._scorm.save();
      }
    });

    // load from scorm
    if (this._scorm && this._scorm.suspendData) {
      const ls = this._scorm.suspendData;
      if (ls && ls.version && ls.version === this._sponge.data.save.version && this._sponge.data.save.shouldPersistData) {

        console.log("Restoring SCORM session", ls);

        if (Object.keys(ls).length === 0 && ls.constructor === Object) {
          this.save();
        } else {
          this._sponge.data.save = ls;
        }
      } else {
        this.events.emit("save");
      }
    }

    this.events.on("complete", (score: number) => {
      if (this._scorm)
        this._scorm.pass(score);
    });

    this.events.on("failed", (score: number) => {
      if (this._scorm)
        this._scorm.fail(score);
    });




  }

  private assertSponge(): void {
    if (this._sponge === undefined) {
      this._sponge = this.pluginManager.get('sponge') as SpongePlugin;
    }
  }


}
